export const HALT_TRADE_REQUESTED = 'HALT_TRADE_REQUESTED';
export const HALT_TRADE_SUCCESS = 'HALT_TRADE_SUCCESS';
export const HALT_TRADE_FAILED = 'HALT_TRADE_FAILED';

export const FETCH_HALT_TRADE_REQUESTED = 'FETCH_HALT_TRADE_REQUESTED';
export const FETCH_HALT_TRADE_SUCCESS = 'FETCH_HALT_TRADE_SUCCESS';
export const FETCH_HALT_TRADE_FAILED = 'FETCH_HALT_TRADE_FAILED';

export const NEW_TRADE_ALERT = 'NEW_TRADE_ALERT';
